const list = [
  { id: 1, label: '行业词' },
  { id: 2, label: '口碑词' },
  { id: 3, label: '品牌词' },
  { id: 4, label: '竞品词' }
]

const getLabelById = (id) => {
  const item = list.find(item => item.id === id)
  return item ? item.label : ''
}

export default {
  list,
  getLabelById
}
